module.exports = __webpack_public_path__ + "static/media/hourglass_top_yellow.c908a4a9.svg";